import { Injectable } from '@angular/core';
import { categories } from 'assets/category-selector-data';
import { branches } from 'assets/json/branch-selector-data';
import { of } from 'rxjs';
import { FeatureToggleService } from '@sc/pas-common';

@Injectable()

export class ListSetService {

    constructor(private featureToggleService: FeatureToggleService) { }

    branchSelectorData() {
        let branchData = branches.branches;

        if (this.featureToggleService.features) {
            branchData = branchData.filter(branch => !this.featureToggleService.features.find(feature => feature.id === branch.hideForFeatureToggle));
            branchData = branchData.filter(branch => !branch.showForFeatureToggle || (branch.showForFeatureToggle && this.featureToggleService.features.find(feature => feature.id === branch.showForFeatureToggle)));
        } else {
            branchData = branchData.filter(branch => !branch.showForFeatureToggle);
        }

        return of(branchData);
    }

    categorySelectorData() {
        return of(categories);
    }
}
